/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
// pageTransition = true;

/** 
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
**/
// pageAjax = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
// parallaxBreakpoint = 768;


(function($) {
	

	$(window).on("load", function(){
	    $('#loader').css('display','none');
	    $('body').addClass('visible');

	    

	    setTimeout(function(){
	     	$('.bg-container').addClass('bg-container-visible');
	    }, 1200);

	    setTimeout(function(){
	     	$('.tessa-header').addClass('tessa-header-visible');
	    }, 1700);

	    


	    var movementStrength = 25;
		var height = movementStrength / $(window).height();
		var width = movementStrength / $(window).width();
		$("#header-image").mousemove(function(e){
		          var pageX = e.pageX - ($(window).width() / 2);
		          var pageY = e.pageY - ($(window).height() / 2);
		          var newvalueX = width * pageX * -1 - 25;
		          var newvalueY = height * pageY * -1 - 50;
		          $('#header-image').css("background-position", newvalueX+"px     "+newvalueY+"px");
		});


		//Disparition header
		var header = $('.header-content');
		var range = 150;

		$(window).on('scroll', function () {
	  
	 	var scrollTop = $(this).scrollTop(),
	    height = header.outerHeight(),
	    offset = height / 2,
	    calc = 1 - (scrollTop - offset + range) / range;

	  	header.css({ 'opacity': calc });

		if (calc > '1') {
			header.css({ 'opacity': 1 });
			} else if ( calc < '0' ) {
				header.css({ 'opacity': 0 });
		}

		});
 
	});

	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
		
		/* Autres fonctions jouées au resize */
		// resizeSlider();
		// resizeNav();
	};

	
	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
	      ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();


		if ( $('body').hasClass('home') ) {
			if ( scrollTop < $('#section-biography').offset().top ) {
				$('.logo, .lang, .social').removeClass('color');
			}

			else if ( ( scrollTop >= $('#section-biography').offset().top ) &&
				      ( scrollTop < $('#section-victories').offset().top ) ) {
				$('.logo, .lang, .social').addClass('color');

			} else if ( ( scrollTop >= $('#section-victories').offset().top ) &&
				      ( scrollTop < $('#section-confidential').offset().top ) ) {
				$('.logo, .lang, .social').removeClass('color');

			} else if ( ( scrollTop >= $('#section-confidential').offset().top ) &&
				      ( scrollTop < $('#section-socialwall').offset().top ) ) {
				$('.logo, .lang, .social').addClass('color');
			}
		}

		if ( $('body').hasClass('single-news') ) {
			if ( scrollTop < $('.content-news').offset().top ) {
				$('.logo, .lang, .social').removeClass('color');
			}

			if ( scrollTop > $('.content-news').offset().top ) {
				$('.logo, .lang, .social').addClass('color');
			}
		}



	};

	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	showLoader = function(url) {
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan2l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.10 } ),
			// TweenMax.fromTo( $pan3l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.20 } ),
			// TweenMax.fromTo( $logo,  0.1, { opacity: 0 }, { opacity: 1, delay: 0.20 } )
		]);
		tl.call(function() {
			// A la fin de l'anim, on redirige vers la nouvelle URLs
			window.location.href = url;
		});
		tl.play();
	};

	var hideLoader = function() {
		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.call(function() {
			initScrollAnimations();
		});
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan1, 0.4, { x: '0' }, { x: '100%', delay: 0 } ),
			// TweenMax.fromTo( $pan2, 0.4, { x: '0' }, { x: '100%', delay: 0.15 } ),
			// TweenMax.fromTo( $logo, 0.2, { opacity: 1 }, { opacity: 0, delay: 0  } )
		]);	
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}


	/*
	   ###     ##    ##   ####  ##     ##       ##          #######    ######     #######   
	  ## ##    ###   ##    ##   ###   ###       ##         ##     ##  ##    ##   ##     ##  
	 ##   ##   ####  ##    ##   #### ####       ##         ##     ##  ##         ##     ##  
	##     ##  ## ## ##    ##   ## ### ##       ##         ##     ##  ##   ####  ##     ##  
	#########  ##  ####    ##   ##     ##       ##         ##     ##  ##    ##   ##     ##  
	##     ##  ##   ###    ##   ##     ##       ##         ##     ##  ##    ##   ##     ##  
	##     ##  ##    ##   ####  ##     ##       ########    #######    ######     #######   
	*/

	
	(function () {

		var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	    }
	 
	    if (!window.requestAnimationFrame)
	        window.requestAnimationFrame = function(callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
	              timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	 
	    if (!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function(id) {
	            clearTimeout(id);
	        };
	}());

	(function () {
				
		var logo,
			logoImage,
			canvas;					

		function gameLoop () {
		
		  window.requestAnimationFrame(gameLoop);

		  logo.update();
		  logo.render();
		}
		
		function sprite (options) {
		
			var that = {},
				frameIndex = 0,
				tickCount = 0,
				ticksPerFrame = options.ticksPerFrame || 0,
				numberOfFrames = options.numberOfFrames || 1;
			
			that.context = options.context;
			that.width   = options.width;
			that.height  = options.height;
			that.image   = options.image;
			
			that.update = function () {

	            tickCount += 1;

	            if (tickCount > ticksPerFrame) {

					tickCount = 0;
					
	                // If the current frame index is in range
	                if (frameIndex < numberOfFrames - 1) {	
	                    // Go to the next frame
	                    frameIndex += 1;
	                }
	            }
	        };
			
			that.render = function () {
			
			  // Clear the canvas
			  that.context.clearRect(0, 0, that.width, that.height);
			  
			  // Draw the animation
			  that.context.drawImage(
			    that.image,
			    frameIndex * that.width / numberOfFrames,
			    0,
			    that.width,
			    that.height,
			    0,
			    0,
			    that.width,
			    that.height);
			};
			
			return that;
		}
		
		// Get canvas
		canvas = document.getElementById("logoAnim");
		canvas.width = 550;
		canvas.height = 446;
		
		// Create sprite sheet
		logoImage = new Image();
		var templateUrl = myScript.template_url;
		logoImage.src   = templateUrl+"/images/sprite-logo.png";	
		
		// Create sprite
		logo = sprite({
			context: canvas.getContext("2d"),
			width: 42350,
			height: 446,
			image: logoImage,
			numberOfFrames: 77,
			ticksPerFrame: 1.5
		});
		
		// Load sprite sheet
		logoImage.addEventListener("load", gameLoop);

	} ());
	
		/*
	 ######    ##         ####  ########   ########   ########   
	##    ##   ##          ##   ##     ##  ##         ##     ##  
	##         ##          ##   ##     ##  ##         ##     ##  
	 ######    ##          ##   ##     ##  ######     ########   
	      ##   ##          ##   ##     ##  ##         ##   ##    
	##    ##   ##          ##   ##     ##  ##         ##    ##   
	 ######    ########   ####  ########   ########   ##     ##  
	*/

	var $slickElement = $('.slider-news');

	$slickElement.slick({
		nextArrow: '.slick-next',
		prevArrow:'.slick-prev',
		autoplay: true,
  		autoplaySpeed: 3000,
		slidesToShow: 3,
		slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 770,
		     	settings: {
		      		slidesToShow: 1,
		    	}
		    }
		]
	});



	var time = 32;
	var $bar,
	  $slick,
	  isPause,
	  tick,
	  percentTime;

	$slick = $('.slider');
	$slick.slick({
	cssEase: 'ease-out',
	fade: true,
	nextArrow: $('.arrow-right'),
	prevArrow: $('.arrow-left'),
	});

	$bar = $('.slider-progress .progress');

	$('.slider-wrapper').on({
	mouseenter: function() {
	  isPause = true;
	},
	mouseleave: function() {
	  isPause = false;
	}
	});

	function startProgressbar() {
	resetProgressbar();
	percentTime = 0;
	isPause = false;
	tick = setInterval(interval, 10);
	}

	function interval() {
	if(isPause === false) {
	  percentTime += 1 / (time+0.1);
	  $bar.css({
	    width: percentTime+"%"
	  });
	  if(percentTime >= 7)
	    {
	      $slick.slick('slickNext');
	      startProgressbar();
	    }
	}
	}


	function resetProgressbar() {
	$bar.css({
	 width: 0+'%' 
	});
	clearTimeout(tick);
	}

	startProgressbar();

	/*
	########   ########      ###      ######    
	##     ##  ##     ##    ## ##    ##    ##   
	##     ##  ##     ##   ##   ##   ##         
	##     ##  ########   ##     ##  ##   ####  
	##     ##  ##   ##    #########  ##    ##   
	##     ##  ##    ##   ##     ##  ##    ##   
	########   ##     ##  ##     ##   ######    
	*/

	// $( '.more' ).mouseover( function() {
	// 	new Dragdealer('slider-dr', {
	// 	  steps: 4,
	// 	  speed: 0.3,
	// 	  loose: true,
	// 	  requestAnimationFrame: true,
	// 	  disabled: true
	// 	});
	// });

	// $( '.more' ).mouseout( function() {
	// 	console.log("coucou tocard");
	// 	new Dragdealer('slider-dr', {
	// 	  steps: 4,
	// 	  speed: 0.3,
	// 	  loose: true,
	// 	  requestAnimationFrame: true,
	// 	  disabled: false
	// 	});
	// });




	/*
	########      ###     ##    ##    ######    ##    ##   ########    #######   ##     ##  
	##           ## ##    ###   ##   ##    ##    ##  ##    ##     ##  ##     ##   ##   ##   
	##          ##   ##   ####  ##   ##           ####     ##     ##  ##     ##    ## ##    
	######     ##     ##  ## ## ##   ##            ##      ########   ##     ##     ###     
	##         #########  ##  ####   ##            ##      ##     ##  ##     ##    ## ##    
	##         ##     ##  ##   ###   ##    ##      ##      ##     ##  ##     ##   ##   ##   
	##         ##     ##  ##    ##    ######       ##      ########    #######   ##     ##  
	*/

	$('[data-fancybox]').fancybox({
		padding: 0,
		helpers: {
			overlay: {
				locked: false
			}
		}
	});

	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	var pageInit = function() {

		/*
		 ######     #######    #######   ##    ##   ####  ########   
		##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
		##         ##     ##  ##     ##  ##  ##      ##   ##         
		##         ##     ##  ##     ##  #####       ##   ######     
		##         ##     ##  ##     ##  ##  ##      ##   ##         
		##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
		 ######     #######    #######   ##    ##   ####  ########   
		*/

		switch( $('html').attr('lang') ){

			case "fr-FR":
				cookieText = "Nous diffusons des cookies afin d’analyser le trafic sur ce site. Les informations concernant l’utilisation que vous faites de notre site nous sont transmises dans cette optique.";
				acceptText = "J'accepte";
				break;

			default:
				cookieText = "We distribute cookies to analyze the traffic on this site. The information concerning the use you make of our site is transmitted to us in this perspective.";
				acceptText = "I accept";
				break;

		}

		$.cookieBar({
			message:       cookieText,
			acceptText:    acceptText,
			declineButton: false,
			expireDays:    30,
			fixed:         true,
			zindex:        10000
		});

		if(jQuery.cookieBar('cookies')){
			//Google Analytics or other code here
		}

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$('body').on('reveal', '.sr', scrollRevealHandler);
		
		$(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7

		/* Autres scripts qui doivent être initialisés */
		// slider.init();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		// Transmission des liens vers la fonction linkHandler()
		$('[data-link]').click(function(e) {
			linkHandler( $(this) );
		}).find('a').click(function(e) {
			e.stopPropagation();
		});

		$('a').click(function(e) {
			e.preventDefault();
			linkHandler( $(this) );
		});

		// Charge la function permettant de gérer le chargement des pages via AJAX
		if( pageAjax ){
			ajaxUrl();
		}
	};


	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();




	// Exemple d'utilisation du plugin Mcube Gmaps
	// $('.map').mcubeGmaps({
		// bounds:  false, // default : true
		// overlay: false, // default : true
		// styles:  [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
	// });

})(jQuery);